
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.875 6a4.875 4.875 0 11-9.75 0 4.875 4.875 0 019.75 0zM0 6a6 6 0 1012 0A6 6 0 000 6zm5.438-3.188V6c0 .188.093.363.25.469l2.25 1.5a.561.561 0 00.78-.157.56.56 0 00-.156-.78l-2-1.332V2.812A.561.561 0 006 2.25a.561.561 0 00-.563.563z","fill":"#58697D"}})])
          )
        }
      }
    